import { useI18n } from "@/i18n/I18nContext";

// On-brand file picker: custom button + filename ellipsis; the native input stays for accessibility/tests.
export const FilePick = ({ id, accept, multiple = false, files, onFiles, disabled, testId, inputRef, label }) => {
  const { t } = useI18n();
  const names = files?.length ? Array.from(files).map((f) => f.name).join(", ") : t("file.none");
  return (
    <label
      htmlFor={id}
      className={`flex min-w-0 max-w-full items-center gap-3 rounded-xl border border-dashed border-[rgba(245,197,66,0.4)] bg-black/40 p-2 transition-colors duration-200 hover:border-[var(--gold)] ${disabled ? "pointer-events-none opacity-60" : "cursor-pointer"}`}
      data-testid={`${testId}-picker`}
    >
      <input
        id={id}
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        className="sr-only"
        onChange={(e) => onFiles(Array.from(e.target.files || []), e)}
        data-testid={testId}
      />
      <span className="shrink-0 rounded-full bg-[var(--gold)] px-3 py-1.5 text-[0.7rem] font-bold uppercase tracking-wide text-black">
        {label || t(multiple ? "file.chooseMany" : "file.choose")}
      </span>
      <span dir="ltr" className="min-w-0 truncate text-xs text-neutral-300" title={names} data-testid={`${testId}-name`}>{names}</span>
    </label>
  );
};
